import Link from "next/link";
import React from "react";
import { MY_ACCOUNT_PAGES } from "../../constants";
import useAuth from "../../contexts/AuthContext";
import LogoSvg from "../svgs/LogoSvg";
import Button from "../ui-kit/buttons/Button";
import RegisterCallToAction from "../ui-kit/call-to-actions/RegisterCallToAction";
import Divider from "../ui-kit/divider/Divider";
import UserLoggedIn from "../ui-kit/user/UserLoggedIn";
import NavBar from "./NavBar";
import useAmplitude from '../../contexts/AmplitudeContext';
import { AMPLITUDE_EVENTS } from '../../constants';


const SideNavBar = () => {
  const { loggedInUser } = useAuth();
  const { amplitude } = useAmplitude();

  const logPublishSolution = async (e) => {
    amplitude.logEvent(AMPLITUDE_EVENTS.PUBLISH_SOLUTION_FROM_HOME_CLICK);
  }

  return (
    <aside
      className="hidden lg:block lg:w-[324px] dark:bg-black-bg border-r pr-8 pl-4
      border-light-divider  dark:border-dark-divider h-full flex-0"
    >
      <div className="flex flex-col h-full">
        <div className="flex items-center justify-center w-full py-3">
          <Link href="/">
            <a>
              <LogoSvg className="w-auto h-8" />
            </a>
          </Link>
        </div>
        <section>
          <Divider />
          <NavBar />
          <Divider />
        </section>
        {loggedInUser ? (
          <section>
            <div className="my-4 mr-4">
              <UserLoggedIn user={loggedInUser} />
            </div>
            <Divider />
            <div onClick={logPublishSolution} className="flex flex-col my-4 space-y-4">
              <Link href={`/perfil?page=${MY_ACCOUNT_PAGES.PROJECTS}`}>
                <a>
                  <Button size="sm" block type="secondary">
                    Publicar Proyecto
                  </Button>
                </a>
              </Link>

              <Link href="/preguntas">
                <a>
                  <Button size="sm" block type="secondary">
                    Pregúntame lo que quieras
                  </Button>
                </a>
              </Link>
            </div>
          </section>
        ) : (
          <div className="hidden md:block">
            <RegisterCallToAction />
          </div>
        )}
      </div>
    </aside>
  );
};

export default SideNavBar;
